function Overlay() {
  return <div
    className={`bg-gray-800 transition opacity-60 absolute w-full h-full top-0 z-20
      }`}
  />
}
export default Overlay
